import RouteWorker from "$lib/test/route?worker";
import { randomCirclePoint } from "random-location";
import type { Location } from "./Client";
import { map } from "./map";
import { regions } from "./regions";
export async function start(
    routes: number,
    amount: number,
    spread = 4,
): Promise<Location[]> {
    const radius = 20_000;
    const center = randomCirclePoint(
        {
            latitude: 52,
            longitude: -1.3,
        },
        radius / 10,
    );
    const workers = [];
    for (let route = 0; route < routes; route++) {
        workers.push(
            new Promise((resolve) => {
                const routeCenter = randomCirclePoint(center, radius * spread);
                const worker = new RouteWorker();
                const routeLocations: Location[] = [];
                worker.onmessage = (e) => {
                    if (e.data.type === "TestDataLocation") {
                        routeLocations.push(e.data.data as Location);
                    }
                    if (e.data.type === "TestDataFinished") {
                        resolve(routeLocations);
                    }
                };
                worker.postMessage({ routeCenter, radius, amount, route });
            }),
        );
    }
    return (await Promise.all(workers)).flat() as Location[];
}
export default { start };
export const regionTest = async () => {
    for (const region of regions.values()) {
        if (region.layer) {
            map.removeLayer(region.layer);
        }
    }
    window.postMessage({ type: "Setup" });
    const numberOfRoutes = 5;
    const locs = await start(numberOfRoutes, 30, 1);
    const colours = await new Promise<Map<string, string>>(
        (resolve, _reject) => {
            window.addEventListener("message", (ev) => {
                if (ev.data.type === "RouteColours") {
                    resolve(ev.data.routeColours);
                }
            });

            window.postMessage(
                {
                    type: "Data",
                    data: {
                        culture: "fr-fr",
                        locations: locs,
                        routes: Object.fromEntries(
                            [...Array(numberOfRoutes).keys()].map((i) => [
                                i,
                                { name: `Route ${i + 1}` },
                            ]),
                        ),
                    },
                },
                "*",
            );
            window.postMessage(
                {
                    type: "Regions",
                    data: {
                        edit: true,
                        regions: [...regions.values()].map((r) => {
                            r.layer = undefined;
                            return r;
                        }),
                    },
                },
                "*",
            );
        },
    );

    const routes = locs.reduce(
        (routes, loc) => {
            routes[loc.routeId] ??= [];
            routes[loc.routeId].push(loc);
            return routes;
        },
        {} as Record<string, Location[]>,
    );
    for (const routeId in routes) {
        const route = routes[routeId];
        window.postMessage(
            {
                type: "GenerateRegionFromPoints",
                data: {
                    points: route,
                    name: routeId,
                    color: colours.get(routeId),
                },
            },
            "*",
        );
    }
};
export const routesTest = async () => {
    const routes = 160;
    const locations = await start(routes, 25);
    const path = locations.reduce((r, l) => {
        let path = r[l.routeId];
        if (!path) {
            path = [];
        }
        path.push([l.latitude, l.longitude]);
        r[l.routeId]= path;
        return r;
    }, {}as Record<string,number[][]>);
    window.postMessage(
        {
            type: "Data",
            data: {
                culture: "fr-fr",
                locations: locations,
                path: path,
                routes: Object.fromEntries(
                    [...Array(routes).keys()].map((i) => [
                        i,
                        { name: `Route ${i + 1}` },
                    ]),
                ),
            },
        },
        "*",
    );
};
export const ReceiveTest = async (event: MessageEvent) => {
    if (!event.data.data || event.data.data === "routes") {
        await routesTest();
        return;
    }
    if (event.data.data === "regions") {
        await regionTest();
        return;
    }
};
